import * as actionTypes from '../action-types';
import { reqByGet } from '@/api/api';
import servers from '@/api/server'


export const updateDateNum = () => {
    return async dispatch => {
        reqByGet(servers.backlogListUndone, {}, res => {
            console.log(res)
            dispatch({
                type: actionTypes.DATE_NUM,
                dateNum: res.total,
            });
        }, err => {
            console.log(err)
        })
    }
}
